export * from './custom-page.component';
export * from './custom-page.module';
